module.exports = __webpack_public_path__ + "img/pause.95aba0c0.png";